import { createFileRoute } from "@tanstack/react-router";

import LeagueScoringForm from "@/components/LeagueProfile/LeagueScoringForm";

const Component = () => {
  const { leagueUuid } = Route.useParams();
  return <LeagueScoringForm leagueUuid={leagueUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/events/series/$leagueUuid/profile/scoring")({
  component: Component,
});
